define.alias("ember-cli-clipboard/helpers/is-clipboard-supported", "calendar/helpers/is-clipboard-supported");